export default __webpack_public_path__ + "static/media/apiToken.2ae2f958.png";